import styled from 'styled-components';
import BackArrow from '~/icons/BackArrow';
import { ThumbnailHeight, TileWidth } from './VehicleTile.styles';

export const Dot = styled.div`
  height: 8px;
  width: 8px;
  background-color: var(--cvna-color-grey-2);
  border-radius: 50%;
  margin: 0 4px;
`;

export const SliderWrapper = styled.div.attrs({
  className: 'mx-auto my-0 relative'
})`
  grid-column: 1;
  grid-row: 1;

  .slick-list {
    width: ${TileWidth}px;
  }

  .slick-dots {
    width: 100%;
    justify-content: center;
    position: absolute;
    bottom: 8%;
    display: flex !important;

    .slick-active > ${Dot} {
      background-color: var(--cvna-color-blue-2);
    }
  }

  .arrow {
    display: none;
  }

  div:hover ~ .arrow,
  .arrow:hover {
    display: inline-block;
  }
`;

export const Image = styled.img.attrs({
  className: `object-cover rounded-t-md w-full`
})`
  height: ${ThumbnailHeight}px;
`;

export const Arrow = styled(BackArrow).attrs({
  className: 'absolute z-index-1'
})`
  stroke: var(--cvna-color-white);
  top: 50%;
  left: 10px;

  &.reversed {
    left: unset;
    right: 10px;
  }
`;
